var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyyrTeed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 943 1385",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3{fill:none;}.cls-4{fill:url(#_10_dpi_30_);stroke:#6b0303;stroke-width:2px;}.cls-4,.cls-2,.cls-3{stroke-miterlimit:10;}.cls-2{stroke:#013501;stroke-width:3px;}.cls-5{fill:#013501;}.cls-6{fill:#231f20;}.cls-7{fill:#534741;font-family:Roboto-MediumItalic, Roboto;font-size:14px;font-style:italic;font-weight:500;}.cls-3{stroke:#534741;}"), /*#__PURE__*/React.createElement("pattern", {
    id: "_10_dpi_30_",
    x: 0,
    y: 0,
    width: 28.8,
    height: 28.8,
    patternTransform: "translate(60.06 216.84)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 28.8 28.8"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    y: 0,
    width: 28.8,
    height: 28.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M28.8,30.96c1.19,0,2.16-.97,2.16-2.16s-.97-2.16-2.16-2.16-2.16,.97-2.16,2.16,.97,2.16,2.16,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M14.4,30.96c1.19,0,2.16-.97,2.16-2.16s-.97-2.16-2.16-2.16-2.16,.97-2.16,2.16,.97,2.16,2.16,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M28.8,16.56c1.19,0,2.16-.97,2.16-2.16s-.97-2.16-2.16-2.16-2.16,.97-2.16,2.16,.97,2.16,2.16,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M14.4,16.56c1.19,0,2.16-.97,2.16-2.16s-.97-2.16-2.16-2.16-2.16,.97-2.16,2.16,.97,2.16,2.16,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M7.2,23.76c1.19,0,2.16-.97,2.16-2.16s-.97-2.16-2.16-2.16-2.16,.97-2.16,2.16,.97,2.16,2.16,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M21.6,23.76c1.19,0,2.16-.97,2.16-2.16s-.97-2.16-2.16-2.16-2.16,.97-2.16,2.16,.97,2.16,2.16,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M7.2,9.36c1.19,0,2.16-.97,2.16-2.16s-.97-2.16-2.16-2.16-2.16,.97-2.16,2.16,.97,2.16,2.16,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M21.6,9.36c1.19,0,2.16-.97,2.16-2.16s-.97-2.16-2.16-2.16-2.16,.97-2.16,2.16,.97,2.16,2.16,2.16Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M0,30.96c1.19,0,2.16-.97,2.16-2.16s-.97-2.16-2.16-2.16-2.16,.97-2.16,2.16,.97,2.16,2.16,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M0,16.56c1.19,0,2.16-.97,2.16-2.16s-.97-2.16-2.16-2.16-2.16,.97-2.16,2.16,.97,2.16,2.16,2.16Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M28.8,2.16c1.19,0,2.16-.97,2.16-2.16s-.97-2.16-2.16-2.16-2.16,.97-2.16,2.16,.97,2.16,2.16,2.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M14.4,2.16c1.19,0,2.16-.97,2.16-2.16s-.97-2.16-2.16-2.16-2.16,.97-2.16,2.16,.97,2.16,2.16,2.16Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M0,2.16c1.19,0,2.16-.97,2.16-2.16S1.19-2.16,0-2.16-2.16-1.19-2.16,0-1.19,2.16,0,2.16Z"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "asjad"
  }, /*#__PURE__*/React.createElement("g", {
    id: "asjad_koos"
  }, /*#__PURE__*/React.createElement("g", {
    id: "myyr_teed"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "raam",
    className: "cls-1",
    width: 943,
    height: 1385
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "558 838 558 1247 538 1247 538 838 558 838"
  }), /*#__PURE__*/React.createElement("path", {
    id: "m\\xFC\\xFCr",
    className: "cls-4",
    d: "M15,818v449H889v-388l-89-61H15Zm854,429H35v-409H785l84,58v351Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M384.88,40.61c-25.56-.15-51.12-.3-76.68-.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "294.21 40.38 300.98 41.68 307.76 42.98 307.76 40.38 307.76 37.78 300.98 39.08 294.21 40.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M518.23,40.61c25.56-.15,51.12-.3,76.68-.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "608.91 40.38 602.13 41.68 595.36 42.98 595.36 40.38 595.36 37.78 602.13 39.08 608.91 40.38"
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(424.34 43.99)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "~ 120m")), /*#__PURE__*/React.createElement("g", {
    id: "tee"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M870.84,379.21c.15-25.56,.3-51.12,.45-76.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "871.06 288.54 869.76 295.31 868.46 302.09 871.06 302.09 873.66 302.09 872.36 295.31 871.06 288.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M870.84,512.56c.15,25.56,.3,51.12,.45,76.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "871.06 603.24 869.76 596.46 868.46 589.69 871.06 589.69 873.66 589.69 872.36 596.46 871.06 603.24"
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(867.46 418.67) rotate(90)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "~ 104m")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M907.84,885c.15-60.35,.3-120.7,.45-181.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "908.06 689.95 906.76 696.73 905.46 703.5 908.06 703.5 910.66 703.5 909.36 696.73 908.06 689.95"
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(904.46 899.67) rotate(90) scale(.83 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Saales\u015Ba 300m")), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "888.5 1384.5 928.5 1384.5 928.5 .5 888.5 .5 888.5 88.5 717.5 88.5 717.44 107.44 889.23 107.5 888.5 1384.5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M132.08,93.04l9.84,13.07c-.62,.2-1.23,.46-1.8,.79-.58,.34-1.11,.73-1.58,1.17l-6.47-15.04m-12.62-21.75l9.79,22.76,9.79,22.76,.09-.05c-1.08-2.66-.06-5.78,2.5-7.27,.93-.54,1.94-.79,2.94-.79,1.76,0,3.47,.79,4.61,2.23l.09-.05-14.9-19.8-14.9-19.79h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 146.25,
    cy: 117.57,
    r: 4.04
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M98.04,119.89l2.12-.49c.65-.12,.86-.33,1.02-.9,.16-.73,.16-1.87,.16-4.44v-14.06c0-1.51-.49-2.08-1.51-2.4l-1.75-.57v-1.51l2.89-.33h3.22l11.21,16.1c1.06,1.59,2.77,4.2,3.18,4.93v-14.35c0-1.47,0-2.69-.04-4.16l-3.18-.69v-1.51l3.38-.33h2.24l3.02,.33v1.51l-2.04,.45c-.77,.12-1.06,.53-1.1,1.47-.08,1.18-.12,1.88-.12,4.12v18.54l-2.93,.33-14.22-20.91v18.18l3.1,.69v1.51l-3.22,.33h-2.85l-2.57-.33v-1.51Z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyyrTeed);
export default __webpack_public_path__ + "static/media/Myyr_teed.d334b20d76de9e0fa7f42c0b5296641d.svg";
export { ForwardRef as ReactComponent };